/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  PreconfiguredSkillReference,
  PreconfiguredSkillReference$inboundSchema,
  PreconfiguredSkillReference$Outbound,
  PreconfiguredSkillReference$outboundSchema,
} from "./preconfiguredskillreference.js";
import {
  SkillReference,
  SkillReference$inboundSchema,
  SkillReference$Outbound,
  SkillReference$outboundSchema,
} from "./skillreference.js";

export type SkillEntry = SkillReference | PreconfiguredSkillReference;

/** @internal */
export const SkillEntry$inboundSchema: z.ZodType<
  SkillEntry,
  z.ZodTypeDef,
  unknown
> = z.union([
  SkillReference$inboundSchema,
  PreconfiguredSkillReference$inboundSchema,
]);
/** @internal */
export type SkillEntry$Outbound =
  | SkillReference$Outbound
  | PreconfiguredSkillReference$Outbound;

/** @internal */
export const SkillEntry$outboundSchema: z.ZodType<
  SkillEntry$Outbound,
  z.ZodTypeDef,
  SkillEntry
> = z.union([
  SkillReference$outboundSchema,
  PreconfiguredSkillReference$outboundSchema,
]);

export function skillEntryToJSON(skillEntry: SkillEntry): string {
  return JSON.stringify(SkillEntry$outboundSchema.parse(skillEntry));
}
export function skillEntryFromJSON(
  jsonString: string,
): SafeParseResult<SkillEntry, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SkillEntry$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SkillEntry' from JSON`,
  );
}
